export default "__VITE_ASSET__Hg494YYw__"